import styled from '@emotion/styled';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const RegistryWebsiteCrossSellWrapper = styled.div`
  display: flex;
  border-radius: 16px;
  overflow: hidden;

  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
    max-width: 228px;
    margin: auto;
  }
`;

export const PhotoSection = styled.div<{ url: string }>`
  flex: 1 0 40%;
  background-color: ${COLORS3.COVE_100};
  background-image: url(${(props) => props.url});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  ${MEDIA_QUERY.MOBILE} {
    flex: unset;
    height: 140px;
  }
`;

export const TextSection = styled.div`
  flex: 1 1 auto;
  padding: ${SPACING.S24};
  background-color: ${COLORS3.BLACK_005};
  text-align: center;

  a {
    color: ${COLORS3.WHITE_100};
    text-decoration: none;

    :hover {
      color: ${COLORS3.WHITE_100};
      text-decoration: none;
    }
  }
`;

export const Text = styled.div`
  margin-bottom: ${SPACING.S16};
  color: ${COLORS3.BAY_100};
  font-family: ${FONT.FONT_FAMILY_SERIF};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGE)};

  ${MEDIA_QUERY.MOBILE} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_REGULAR)};
  }
`;
